import { isEmpty, reject } from '../../utils/fp';
import facetParser from './facetParser';

export default options => facets => {
  const withBuckets = reject(facet => isEmpty(facet.buckets), facets);
  return Object.entries(withBuckets).map(facetParser(options));
};
